import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { EnumStatusSolicitacaoTecnica } from "../../../models/enum/status-solicitcao-tecnica.enum";
import { IResponsavelSelectModel } from "../../../models/responsaveis.model";
import { SolicitacaoTecnicaService } from "../../../services/solicitacao-tecnica.service";
import { BaseListComponent } from "../../../shared/components/base-list/base-list.component";
import { ISolicitacaoTecnicaModel } from "../../../models/solicitacao-tecnica.model";
import { IFiltroSolicitacaoTecnica } from "../../../models/filtros/filtro-solicitacao-tecnica.model";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "../../../services/auth.service";
import { IUnidadeGestoraSelectModel } from "../../../models/unidade-gestora.model";
import { EnumRecursoPerfil } from "../../../models/enum/recurso-perfil.enum";
import { EnumAcaoRecurso } from "../../../models/enum/acao-recurso.enum";

@Component({
	selector: "app-solicitacao-tecnica-list",
	templateUrl: "./solicitacao-tecnica-list.component.html",
	styleUrls: ["./solicitacao-tecnica-list.component.scss"]
})

export class SolicitacaoTecnicaListComponent
	extends BaseListComponent
	implements OnInit {

	public EnumStatusSolicitacaoTecnica = EnumStatusSolicitacaoTecnica;
	public dataSource = new MatTableDataSource<any>([]);
	public selectedModel: ISolicitacaoTecnicaModel;
	public pageEvent: any;
	public semDados = true;
	public displayedColumns: string[] = [
		"selecao",
		"documentoAssociado",
		"referencia",
		"numero",
		"ug",
		"assunto",
		"prazo",
		"status"
	];

	public responsaveis = [] as IResponsavelSelectModel[];

	public arrayStatus = [
		{ codigo: EnumStatusSolicitacaoTecnica.NaoRespondida, descricao: "Não Respondida" },
		{ codigo: EnumStatusSolicitacaoTecnica.SolicitacaoProrrogacao, descricao: "Solicitação de Prorrogação" },
		{ codigo: EnumStatusSolicitacaoTecnica.RespondidaParcialmente, descricao: "Respondida Parcialmente" },
		{ codigo: EnumStatusSolicitacaoTecnica.RespondidaTotalmente, descricao: "Respondida Totalmente" }
	];

	public unidades: IUnidadeGestoraSelectModel[] = [];

	public form: FormGroup = this.fb.group({
		prazoResposta: [''],
		numeroOpa: [''],
		numeroOsa: [''],
		numeroSolicitacao: [''],
		assuntoSolicitacao: [''],
		status: [''],
		responsavelId: [''],
		tipo: [1],
		listUnidadeGestoraId: [[]]
	});

	public totalItens: number;

	public filtro = {
		itensPorPagina: 15,
		tipo: 1,
	} as IFiltroSolicitacaoTecnica;

	public EhAuditor: boolean = false;
	public EhLotadoTce: boolean = false;
	public podeConsultar: boolean = false;
	public podeVisualizar: boolean = false;
	public podeResponder: boolean = false;

	public usuarioLogadoEhRespSolic: boolean = false;
	public usuarioLogadoEhRespUG: boolean = false;
	public usuarioLogadoEhDelegPermUG: boolean = false;
	public podeResponderSolic: boolean = false;
	dataAtual = new Date();
	public dataVencida: boolean = false;
	public selectedRow: ISolicitacaoTecnicaModel;
	public temItemDelegado: boolean = false;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;

	constructor(
		private solicitacaoTecnicaService: SolicitacaoTecnicaService,
		private router: Router,
		public fb: FormBuilder,
		private toastr: ToastrService,
		public authService: AuthService,

	) {
		super();
	}

	ngOnInit(): void {

		this.GetPerfil();
		if (this.podeConsultar) {
			this.CarregaDados();
		}
	}

	ngAfterViewInit() {

		this.dataSource.paginator = this.paginator;
		this.dataSource.sortingDataAccessor = () => '';
	}

	private GetPerfil(): void {

		this.podeConsultar = this.authService.possuiPermissao(EnumRecursoPerfil.SolicitacoesTecnicas.toString(), EnumAcaoRecurso.Consultar);
		this.podeVisualizar = this.authService.possuiPermissao(EnumRecursoPerfil.SolicitacoesTecnicas.toString(), EnumAcaoRecurso.Visualizar);
		this.podeResponder = this.authService.possuiPermissao(EnumRecursoPerfil.SolicitacoesTecnicas.toString(), EnumAcaoRecurso.Responder);
		this.EhAuditor = this.authService.possuiPerfis(['Auditor-GERAL']);
		this.EhLotadoTce = this.authService.possuiPerfis(['TribunaldeContas']);
	}

	public CarregaDados() {

		if (!this.EhAuditor && !this.EhLotadoTce) {

			const responsavelId = this.authService.usuario.id;

			this.solicitacaoTecnicaService.obterUGsByResponsavelId(responsavelId)
				.then((res) => {
					if (!res.dados || res.dados.length === 0) {
						this.podeConsultar = false;
						return;
					}
					this.unidades = res.dados;
					this.form.patchValue({ listUnidadeGestoraId: res.dados.map(u => u.value) });
					setTimeout(() => {
						this.configurarFiltro();
						this.buscar();
						this.ObterResponsaveis();
					});
				})
				.catch((err) => {
					this.toastr.error(err?.mensagem?.descricao ?? err, "Atenção");
				});
		} else {
			setTimeout(() => {
				this.configurarFiltro();
				this.buscar();
				this.ObterResponsaveis();
			});
		}
	}

  public obterReferencia(tipoTrabalhoCodigo: number): string {
    switch (tipoTrabalhoCodigo) {
      case 7:
        return 'Auditoria/Planejamento';
      case 14:
        return 'Auditoria/Execução';
      default:
        return '';
    }
  }

	public ObterResponsaveis() {

		if (!this.unidades || this.unidades.length === 0) {

			this.solicitacaoTecnicaService.obterResponsaveisUGs()
				.then((res) => {
					this.responsaveis = (res.dados ?? [])
						.filter(r => !!r?.text)
						.sort((a, b) => a.text.localeCompare(b.text));
				})
				.catch((err) => {
					this.toastr.error(err?.mensagem?.descricao ?? err, "Atenção");
				});
			return;
		}

		const requisicoes = this.unidades.map(unidade =>
			this.solicitacaoTecnicaService.obterResponsaveis(unidade.value)
		);

		Promise.all(requisicoes)
			.then((respostas) => {

				// Juntar todos os arrays em um só com map + reduce
				const todosResponsaveis = respostas
					.map(res => res.dados ?? [])
					.reduce((acc, curr) => acc.concat(curr), [])
					.filter(r => !!r?.text);

				// Remover duplicados pelo value
				const mapUnicos = new Map<string, any>();
				todosResponsaveis.forEach(responsavel => {
					if (!mapUnicos.has(responsavel.value)) {
						mapUnicos.set(responsavel.value, responsavel);
					}
				});

				// Converter para array e ordenar por text
				this.responsaveis = Array.from(mapUnicos.values())
					.sort((a, b) => a.text.localeCompare(b.text));
			})
			.catch((err) => {
				this.toastr.error(err?.mensagem?.descricao ?? err, "Atenção");
			});
	}

	public visualizar(id: number) {
		this.router.navigate([`/solicitacao-tecnica/${id}/visualizar`]);
	}

	public responder(id: number) {
		this.router.navigate([`/solicitacao-tecnica/${id}/responder`]);
	}

	public configurarFiltro() {
		this.filtro.pagina = this.paginator.pageIndex + 1;
		this.filtro.itensPorPagina = this.paginator?.pageSize;
		this.filtro.colunaOrder = this.sort?.active;
		this.filtro.direcao = this.sort?.direction;
		Object.assign(this.filtro, this.form.getRawValue());
	}

	public filtrar() {
		this.paginator.firstPage();
		this.configurarFiltro();
		this.buscar();
	}

	public buscar() {

		this.selectedModel = null;

		this.solicitacaoTecnicaService
			.filtrar(this.filtro)
			.then((res) => {
				this.dataSource = new MatTableDataSource<any>(
					res.dados?.resultado
				);

				this.totalItens = res.dados.totalItens;
				this.dataSource.sortingDataAccessor = () => '';
				this.dataSource._updateChangeSubscription();
				this.semDados = this.dataSource.filteredData.length === 0;

			})
			.catch((err) => {
				this.toastr.error(err?.mensagem?.descricao ?? err, "Atenção");
			});
	}


	public async selecionar(item: any) {


		this.selectedModel =
			!this.selectedModel || this.selectedModel.id !== item.id
				? item
				: null;

		if (this.selectedModel?.id) {

			//-> verifica se esta vencida
			var hoje = new Date(this.dataAtual.getFullYear(), this.dataAtual.getMonth(), this.dataAtual.getDate());

			if (new Date(this.selectedModel?.prazo) < hoje) {
				this.dataVencida = true;
			}
			else {
				this.dataVencida = false;
			}

			//-> verifica se tem algum item delegado
			await this.verificaItemDelegado(this.selectedModel.id);

			this.usuarioLogadoEhRespSolic = this.authService.usuario.id == this.selectedModel?.internaResponsavelId;
			this.usuarioLogadoEhRespUG = this.authService.usuario.id == this.selectedModel?.internaUnidadeGestora.responsavelId;
			this.usuarioLogadoEhDelegPermUG = this.authService.usuario.id == this.selectedModel?.internaUnidadeGestora.responsavelDelegadoPermanenteId;
			//-> habilita ou nao conforme regra
			this.podeResponderSolic = (this.podeResponder) &&
				(this.usuarioLogadoEhRespSolic || this.usuarioLogadoEhRespUG || this.usuarioLogadoEhDelegPermUG || this.temItemDelegado) &&
				(!this.dataVencida) &&
				(this.selectedModel?.status.codigo == 3 || this.selectedModel?.status.codigo == 5 || this.selectedModel?.status.codigo == 7 || this.selectedModel?.status.codigo == 8)
		}
		else {
			this.dataVencida = true;
			this.temItemDelegado = false;
			this.usuarioLogadoEhRespSolic = false;
			this.usuarioLogadoEhRespUG = false;
			this.usuarioLogadoEhDelegPermUG = false;
			this.podeResponderSolic = false;
		}
	}

	public verificaItemDelegado(solicitacaoId: number): Promise<void> {
		return this.solicitacaoTecnicaService.obterPorId(solicitacaoId)
			.then((res) => {
				this.selectedRow = res.dados;

				this.temItemDelegado = this.selectedRow.item.some(
					item => item.responsavelId === this.authService.usuario.id
				);
			});
	}

	pageChanged(e) {
		this.filtro.pagina = e.pageIndex + 1;
		e.pageIndex = this.filtro.pagina;
		this.filtro.itensPorPagina = e.pageSize;
		this.buscar();
	}

  sortData() {
		this.paginator.firstPage();
		this.configurarFiltro();
		this.buscar();
  }

  //metodo desabilitado porque a ordenação está sendo tratada no backend
  public sortingDataAccessor_old = (item, property) => {

		switch (property) {
			case "documentoAssociado":
				return item?.ano_Sequencial;
			case "referencia":
				return item?.tipoTrabalho?.codigo;
			case "numero":
				return item?.numero;
			case "ug":
				return item?.internaUnidadeGestoraId;
			case "assunto":
				return item?.assunto;
			case "prazo":
				return item?.prazo;
			case "status":
				return item?.status?.descricao;
			default:
				return item[property];
		}
	};
}
